// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Anastasia Chesnovskaya <anastasia.chesnovskaya@celadon.ae>

import React, { useState, useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import {
  Button,
  Input,
  SearchInput,
  // SearchBar 
} from '../../../../components';
import styles from './styles';

const CollectionDetails2 = (props) => {
  const {
    classes,
    onPress,
    tradeCustomer,
    setFieldForTradeCustomer,
    setFieldForTradeCustomerAddress,
    resetError,
    changeField,
    searchAddress,
    requestSelectedAddress,
    postcode,
    addresses,
    address,
  } = props;

  const text1 = 'Send your trade items by arranging a collection through our courier service.';
  const text2 = 'Please enter the pick up information';
  const text3 = `Please provide us with a telephone number, so that the courier
  can git in contact with you if there are any problems with your collection.`;

  const [error, setError] = useState(null);

  useEffect(() => {
    setError(null);
  }, [address]);

  const findEmptyFields = (object) => {
    const errors = {
      Postcode: 'Please specify postcode.',
      AddressLine1: 'Please specify Address Line1.',
      AddressLine2: 'Please specify Address Line2.',
      Town: 'Please specify Town.',
      County: 'Please specify County.',
      date: 'Please specify your pickup date',
      boxes: 'Please specify your Number of boxes',
      phoneNumber: 'Please specify your contact number',
    };
    setError(null);
    return (
      Object.keys(object).every(
        (key) => {
          if (!object[key]) {
            if (['AddressLine2', 'AddressLine3'].includes(key)) {
              return true;
            }
            setError(errors[key]);
            return false;
          }
          return true;
        }
      )
    );
  };

  const isValidData = () => {
    const errorBoxes = 'Number of boxes must be numeric';
    const regex = /^[0-9]+$/;

    if (findEmptyFields(address)) {
      if (findEmptyFields(tradeCustomer)) {
        if (regex.test(tradeCustomer.boxes)) {
          return true;
        }
        setError(errorBoxes);
        return false;
      }
      return false;
    }
    return false;
  };

  const onChangeAddressInput = (value, name) => {
    resetError();
    setError(null);
    setFieldForTradeCustomerAddress(value, name);
  };

  const onChangeInput = (value, name) => {
    resetError();
    setError(null);
    setFieldForTradeCustomer(name, value);
  };

  return (
    <div className={classes.container}>
      <p className={classes.text1}>{text1}</p>
      <p className={classNames(classes.text1, classes.text2)}>{text2}</p>
      <form className={classes.form} autoComplete={'off'}>
        {/* <SearchBar
          changeField={changeField}
          onChange={onChangeAddressInput}
          postcode={postcode}
        /> */}
        <SearchInput
          changeField={changeField}
          searchAddress={searchAddress}
          requestSelectedAddress={requestSelectedAddress}
          postcode={postcode}
          addresses={addresses}
        />
        <Input
          label={'Postcode:'}
          name={'Postcode'}
          value={address.Postcode}
          onChange={onChangeAddressInput}
        />
        <Input
          label={'Address line 1:'}
          name={'AddressLine1'}
          value={address.AddressLine1}
          onChange={onChangeAddressInput}
        />
        <Input
          label={'Address line 2:'}
          name={'AddressLine2'}
          value={address.AddressLine2}
          onChange={onChangeAddressInput}
        />
        <Input
          label={'Town:'}
          name={'Town'}
          value={address.Town}
          onChange={onChangeAddressInput}
        />
        <Input
          label={'County:'}
          name={'County'}
          value={address.County}
          onChange={onChangeAddressInput}
        />
        <Input
          label={'Your pickup date'}
          name={'date'}
          dateType
          value={tradeCustomer.date}
          onChange={onChangeInput}
        />
        <Input
          label={'Number of boxes/totes that need collecting?'}
          name={'boxes'}
          value={tradeCustomer.boxes}
          onChange={onChangeInput}
        />
        <Input
          label={'Your contact number'}
          name={'phoneNumber'}
          value={tradeCustomer.phoneNumber}
          onChange={onChangeInput}
        />
      </form>
      <span className={classes.helperText}>{text3}</span>
      {error ? <p className={classes.error}>{error}</p> : (
        props.error && <p className={classes.error}>{props.error}</p>
      )}
      <Button
        style={error || props.error ? classes.buttonWithError : classes.button}
        text={'Book Collection'}
        onPress={() => {
          if (isValidData()) {
            onPress();
          }
        }}
      />
    </div>
  );
};

CollectionDetails2.propTypes = {
  classes: PropTypes.object,
  onPress: PropTypes.func,
  tradeCustomer: PropTypes.object,
  setFieldForTradeCustomer: PropTypes.func,
  setFieldForTradeCustomerAddress: PropTypes.func,
  error: PropTypes.string,
  resetError: PropTypes.func,
  changeField: PropTypes.func,
  searchAddress: PropTypes.func,
  requestSelectedAddress: PropTypes.func,
  postcode: PropTypes.string,
  addresses: PropTypes.array,
  address: PropTypes.object,
};

CollectionDetails2.defaultProps = {
  classes: {},
  onPress: () => { },
  tradeCustomer: {
    date: null,
    boxes: null,
    phoneNumber: null
  },
  setFieldForTradeCustomer: () => { },
  setFieldForTradeCustomerAddress: () => { },
  error: null,
  resetError: () => { },
  changeField: () => { },
  searchAddress: () => { },
  requestSelectedAddress: () => { },
  postcode: null,
  addresses: [],
  address: [],
};

export default withStyles(styles)(CollectionDetails2);
